import React from "react";
import { MemberSecureCard } from "@icoach/components";
import { Box, Chip, Typography } from "@curves/ui-base";
import { orderStatusColorMap } from "@icoach/accountBook/staticData";
import { formatCurrencyFn } from "@util/utils";

export const getBillingCreditCardRowsLabel = () => [
	{
		cellKey: "memberID",
		headerLabel: "會員",
		align: "left",
		maxWidth: 20.4,
		formatCell: (_v, { displayName, maskDisplayName, memberNo, memberPicturePath }, { isRevealed }) => {
			return <MemberSecureCard name={displayName} maskName={maskDisplayName} avatar={memberPicturePath} memberNo={memberNo} isRevealed={isRevealed} />;
		},
	},
	{
		cellKey: "transactionStatusText",
		headerLabel: "交易狀態",
		align: "center",
		formatCell: (cellValue, { transactionStatus = 0 }) => {
			return <Chip label={cellValue} color={orderStatusColorMap.get(transactionStatus)} />;
		},
	},
	{
		cellKey: "transactionTypeText",
		headerLabel: "交易類型",
		align: "center",
	},
	{
		cellKey: "itemName",
		headerLabel: "品項",
		align: "center",
	},
	{
		cellKey: "transactionPrice",
		headerLabel: "交易金額",
		align: "center",
		formatCell: cellValue => {
			return formatCurrencyFn(cellValue);
		},
	},
	{
		cellKey: "creditCardNo",
		headerLabel: "信用卡",
		maxWidth: 21,
		formatCell: (cellValue, { cardExpiryDate }) => {
			return (
				<Box className="payment-card-content">
					<Typography className={"title"} variant="body1" component={"h6"}>
						{cellValue}
					</Typography>
					{cardExpiryDate ? (
						<Typography className={"sub-title font-color-3"} variant="body2">
							{`有效期限：${cardExpiryDate}`}
						</Typography>
					) : (
						""
					)}
				</Box>
			);
		},
	},
	{
		cellKey: "note",
		headerLabel: "備註",
		maxWidth: 30,
	},
];
